import * as React from "react";
import { CustomToaster } from '../../components'

import s from "./RootComponent.module.scss";

interface IProps {
	header?: JSX.Element;
	children?: JSX.Element;
	footer?: JSX.Element;
	contentId: string;
}

export const RootComponent = (props: IProps): JSX.Element => (
	<div className={s.root}>
		<CustomToaster />
		<div className={s.root__column}>
			<div className={[s.root__item, s.root__header].join(" ")}>
				{!!props.header && props.header}
			</div>
			<div
				className={[s.root__item, s.root__content].join(" ")}
				id={props.contentId}
			>
				{props.children}
			</div>
			<div className={[s.root__item, s.root__footer].join(" ")}>
				{!!props.footer && props.footer}
			</div>
		</div>
	</div>
);
